// src/driver/profile/ProfileInfoTab.tsx
import React from "react";
import styles from "../Styles/DriverProfile.module.css"
import { MotoristaData } from "./types";

interface ProfileInfoTabProps {
    motoristaData: MotoristaData;
    BASE_URL: string;
    formatDate: (dateStr: string) => string;
}

const ProfileInfoTab: React.FC<ProfileInfoTabProps> = ({ motoristaData, BASE_URL, formatDate }) => {
    return (
        <div className="card settings mb-4">
            <div className="card-header">
                <h6>Profile Information</h6>
            </div>
            <div className="card-body">
                <div className={styles.avatarWrapper}>
                    {motoristaData.fotoId ? (
                        <img
                            src={`${BASE_URL}/uploads/${motoristaData.fotoId}`}
                            alt="Profile"
                            className={styles.avatarImg}
                        />
                    ) : (
                        <div className={styles.avatarFallback}>
                            {motoristaData.nome
                                .split(' ')
                                .map(n => n[0])
                                .join('')
                                .toUpperCase()}
                        </div>
                    )}
                </div>

                <div className={styles.section}>
                    <h6 className={styles.sectionTitle}>Description</h6>
                    <p>{motoristaData.descricao || 'No description provided.'}</p>
                </div>

                <div className={styles.section}>
                    <h6 className={styles.sectionTitle}>Personal Information</h6>
                    <div className={styles.infoGrid}>
                        <div><strong>Name:</strong> {motoristaData.nome}</div>
                        <div><strong>Place of Birth:</strong> {motoristaData.naturalidade}</div>
                        <div><strong>Country:</strong> {motoristaData.pais}</div>
                        <div><strong>ID Document:</strong> {motoristaData.documento}</div>
                        <div><strong>Driving License #:</strong> {motoristaData.numeroCartaConducao}</div>
                        <div><strong>Phone:</strong> {motoristaData.telefone}</div>
                        <div><strong>Email:</strong> {motoristaData.email}</div>
                        <div><strong>Address:</strong> {motoristaData.morada}</div>
                        <div><strong>Issue Date:</strong> {formatDate(motoristaData.dataExpedicao)}</div>
                        <div><strong>Expiry Date:</strong> {formatDate(motoristaData.dataValidade)}</div>
                        <div><strong>Category:</strong> {motoristaData.categoria}</div>
                        <div><strong>Languages:</strong> {motoristaData.idiomas.join(', ')}</div>
                        <div><strong>Criminal Record:</strong> {motoristaData.registoCriminal || 'Not provided'}</div>
                    </div>
                </div>

                <div className="alert alert-info mt-3">
                    To update your profile information, please contact your company.
                </div>
            </div>
        </div>
    );
};

export default ProfileInfoTab;
